import {get} from '../models/Category';

const getCategories = (caller) => {
    return {
        type: "GET_CATEGORIES",
        payload: get(caller)
    }
};

const getCategory = (caller, payload) => {
    return {
        type: "GET_CATEGORY",
        payload: get(caller, payload)
    }
};

export {getCategories, getCategory};


// WEBPACK FOOTER //
// ./src/actions/Category.js